import React from 'react';
import { AlertTriangleIcon, TrendingDownIcon, AlertCircleIcon, ArrowRightIcon } from 'lucide-react';
const AlertsEmail = () => {
  return <div className="min-h-screen bg-gray-50 py-12 px-4" data-id="element-978">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-979">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-600 to-orange-600 px-8 py-12 text-center" data-id="element-980">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-981">
            <AlertTriangleIcon size={32} className="text-red-600" data-id="element-982" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-983">
            Alerta Financiera Importante
          </h1>
          <p className="text-red-100 text-lg" data-id="element-984">Requiere tu atención inmediata</p>
        </div>
        {/* Content */}
        <div className="px-8 py-10" data-id="element-985">
          <div className="mb-8" data-id="element-986">
            <p className="text-gray-700 text-lg mb-4" data-id="element-987">Hola Ana,</p>
            <p className="text-gray-700 mb-4" data-id="element-988">
              Hemos detectado algunas situaciones en{' '}
              <strong data-id="element-989">PYME Solutions</strong> que requieren tu atención
              inmediata.
            </p>
          </div>
          {/* Critical Alerts */}
          <div className="mb-8" data-id="element-990">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center space-x-2" data-id="element-991">
              <AlertCircleIcon size={24} className="text-red-600" data-id="element-992" />
              <span data-id="element-993">Alertas Críticas</span>
            </h2>
            <div className="space-y-4" data-id="element-994">
              {/* Alert 1 */}
              <div className="border-l-4 border-red-500 bg-red-50 p-4 rounded-r-lg" data-id="element-995">
                <div className="flex items-start justify-between mb-2" data-id="element-996">
                  <h3 className="font-semibold text-red-900" data-id="element-997">
                    Flujo de caja negativo
                  </h3>
                  <span className="text-xs text-red-600 bg-red-100 px-2 py-1 rounded-full" data-id="element-998">
                    URGENTE
                  </span>
                </div>
                <p className="text-sm text-red-800 mb-3" data-id="element-999">
                  Tu flujo de efectivo ha sido negativo por segundo mes
                  consecutivo. El balance actual es de -$43,700 MXN.
                </p>
                <div className="flex items-center space-x-4 text-sm" data-id="element-1000">
                  <div data-id="element-1001">
                    <span className="text-red-600 font-medium" data-id="element-1002">
                      Balance actual:
                    </span>
                    <span className="text-red-900 ml-2 font-semibold" data-id="element-1003">
                      $245,300 MXN
                    </span>
                  </div>
                  <div data-id="element-1004">
                    <span className="text-red-600 font-medium" data-id="element-1005">Cambio:</span>
                    <span className="text-red-900 ml-2 font-semibold" data-id="element-1006">
                      -15.2%
                    </span>
                  </div>
                </div>
              </div>
              {/* Alert 2 */}
              <div className="border-l-4 border-orange-500 bg-orange-50 p-4 rounded-r-lg" data-id="element-1007">
                <div className="flex items-start justify-between mb-2" data-id="element-1008">
                  <h3 className="font-semibold text-orange-900" data-id="element-1009">
                    Inventario elevado
                  </h3>
                  <span className="text-xs text-orange-600 bg-orange-100 px-2 py-1 rounded-full" data-id="element-1010">
                    IMPORTANTE
                  </span>
                </div>
                <p className="text-sm text-orange-800 mb-3" data-id="element-1011">
                  El inventario está 45% por encima del promedio histórico. Esto
                  puede afectar tu liquidez.
                </p>
                <div className="flex items-center space-x-4 text-sm" data-id="element-1012">
                  <div data-id="element-1013">
                    <span className="text-orange-600 font-medium" data-id="element-1014">
                      Inventario actual:
                    </span>
                    <span className="text-orange-900 ml-2 font-semibold" data-id="element-1015">
                      $312,500 MXN
                    </span>
                  </div>
                </div>
              </div>
              {/* Alert 3 */}
              <div className="border-l-4 border-yellow-500 bg-yellow-50 p-4 rounded-r-lg" data-id="element-1016">
                <div className="flex items-start justify-between mb-2" data-id="element-1017">
                  <h3 className="font-semibold text-yellow-900" data-id="element-1018">
                    Cuentas por cobrar elevadas
                  </h3>
                  <span className="text-xs text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full" data-id="element-1019">
                    ATENCIÓN
                  </span>
                </div>
                <p className="text-sm text-yellow-800 mb-3" data-id="element-1020">
                  Las cuentas por cobrar aumentaron 22.1% este mes. Considera
                  revisar tu estrategia de cobranza.
                </p>
                <div className="flex items-center space-x-4 text-sm" data-id="element-1021">
                  <div data-id="element-1022">
                    <span className="text-yellow-600 font-medium" data-id="element-1023">
                      Cuentas por cobrar:
                    </span>
                    <span className="text-yellow-900 ml-2 font-semibold" data-id="element-1024">
                      $187,350 MXN
                    </span>
                  </div>
                  <div data-id="element-1025">
                    <span className="text-yellow-600 font-medium" data-id="element-1026">
                      Días promedio:
                    </span>
                    <span className="text-yellow-900 ml-2 font-semibold" data-id="element-1027">
                      20 días
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Recommendations */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8" data-id="element-1028">
            <h2 className="text-lg font-semibold text-blue-900 mb-4" data-id="element-1029">
              Recomendaciones inmediatas
            </h2>
            <ul className="space-y-3" data-id="element-1030">
              <li className="flex items-start space-x-3" data-id="element-1031">
                <ArrowRightIcon size={20} className="text-blue-600 mt-0.5" data-id="element-1032" />
                <span className="text-blue-900" data-id="element-1033">
                  Revisa y reduce gastos no esenciales para mejorar el flujo de
                  caja
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1034">
                <ArrowRightIcon size={20} className="text-blue-600 mt-0.5" data-id="element-1035" />
                <span className="text-blue-900" data-id="element-1036">
                  Implementa estrategias para reducir el inventario
                  (promociones, descuentos)
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1037">
                <ArrowRightIcon size={20} className="text-blue-600 mt-0.5" data-id="element-1038" />
                <span className="text-blue-900" data-id="element-1039">
                  Acelera la cobranza de cuentas pendientes
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-1040">
                <ArrowRightIcon size={20} className="text-blue-600 mt-0.5" data-id="element-1041" />
                <span className="text-blue-900" data-id="element-1042">
                  Considera opciones de financiamiento a corto plazo si es
                  necesario
                </span>
              </li>
            </ul>
          </div>
          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-1043">
            <a href="/" className="inline-block bg-red-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-red-700 transition-colors" data-id="element-1044">
              Ver Dashboard Completo
            </a>
          </div>
          {/* Support */}
          <div className="border-t border-gray-200 pt-6" data-id="element-1045">
            <p className="text-gray-600 text-sm mb-2" data-id="element-1046">
              ¿Necesitas ayuda para resolver estas alertas?
            </p>
            <p className="text-gray-600 text-sm" data-id="element-1047">
              Nuestro equipo de expertos está disponible en{' '}
              <a href="mailto:soporte@financepro.com" className="text-blue-600 hover:text-blue-700" data-id="element-1048">
                soporte@financepro.com
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200" data-id="element-1049">
          <p className="text-center text-gray-600 text-sm mb-2" data-id="element-1050">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
          <p className="text-center text-gray-500 text-xs" data-id="element-1051">
            Recibiste este correo porque tienes alertas activadas en tu cuenta.
          </p>
        </div>
      </div>
    </div>;
};
export default AlertsEmail;